import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export class SeccionInformativa extends React.PureComponent<{ titulo: string }> {
    render() {
        return (
            <div style={{marginTop: "65px", display: "flex",flexDirection: "row"}}>
                <div style={{flex: "1 0 auto"}} />
                <div style={{width: "540px", flex: "0 1 auto"}}>
                    <span style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "12px", fontFamily: "'Montserrat', sans-serif" }}>
                        {this.props.titulo}
                    </span>
                    <div style={{
                        width: "134px",
                        height: "1px",
                        background: "rgba(245, 102, 0, 1)"
                    }} />
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "570px"
                    }}>
                        <div style={{
                            flex: "0 1 auto",
                            width: "1px",
                            height: "134px",
                            background: "rgba(245, 102, 0, 1)"
                        }} />
                        <div style={{ flex: "1 0 0" }}>
                            {this.props.children}
                        </div>
                    </div>
                </div>
                <div style={{flex: "1 0 auto"}} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/seccion.tsx